import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';
import QRCode from "qrcode.react";

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  const buttonEl = useRef(null);

  const [password, setPassword] = useState("");
  // const [uploadFile, setUploadFile] = useState<File | null>(null);

  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // パスワード表示
  function viewPassword(checked){
    const userPassword = document.getElementById('m_user_password');
    if(checked){
      userPassword.setAttribute('type', 'text');
    }else{
      userPassword.setAttribute('type', 'password');
    }
  }

  // ダウンロード
  function submitDownload(){
    setIsLoading(true);
    setErrorMessage(""); 

    axios.get(
      '/api/internal/certificates/download', { params: { password: password, url_key: props.url_key }})
    .then(function (response) {
      window.location.href = response.data.url;
    }).catch(error => {
      setErrorMessage(error.response.data.message);
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }).finally(() => {
      setIsLoading(false);
    });
  }

  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }
      <h3>証明書のダウンロード</h3>
      <br/>
      <div className="actions text-right">
        <button className="btn btn-primary" data-toggle="modal" data-target="#viwe_ur_qr_modal">URLのQRコード表示</button>
       </div>
      <div className="form-group">
          <label htmlFor="m_user_password">ダウンロードパスワード</label> <span className="label label-danger ml5">必須</span>
          <div className="password_area">
            <div className="w100p">
              <input className="form-control" name="download-password" autoComplete="new-password" placeholder="パスワードを入力してください" type="password" id="m_user_password" onChange={(e) => setPassword(e.target.value)}/>
              <div className="felx_center">
                <input className="mt0" type="checkbox" id="show_password" onChange={(e) => viewPassword(e.target.checked)}/>
                <label className="font_size_s mb0" htmlFor="show_password">パスワードを表示する</label>
              </div>
            </div>
          </div>
       </div>

       <div className="actions text-center">
          <button className="btn btn-primary" onClick={ submitDownload }>ダウンロード</button>
       </div>

       <div className="modal fade" data-backdrop="static" id="viwe_ur_qr_modal">
          <div className="modal-dialog modal-width">
            <div className="modal-content">
              <div className="modal-header bg-success">
                <button type="button" className="close" data-dismiss="modal" ref={buttonEl}>
                  <span aria-hidden="true">&#215;</span><span className="sr-only">閉じる</span>
                </button>
                <h4 className="modal-title text-center modal-title-align">
                  証明書ダウンロードページURL
                </h4>
              </div> {/* /modal-header */}

              <div className="modal-body interview-status-modal-body">

                <div className="form-group">
                  <div>QRコードを読み取ってください</div>
                  <br/>
                  <QRCode value={`https://${location.hostname}/certificates/download?url_key=${props.url_key}`} size="200"/>
                </div>

                <hr style={{width: "400px"}} />
              </div> {/* /modal-body */}
            </div> {/* /modal-content */}
          </div> {/* /modal-dialog */}
        </div> {/* /modal */}
    </LoadingOverlay>
    )
}
export default Index;